module.exports = __webpack_public_path__ + "img/智能健康养老设备项目商业计划书_09.4a82362c.png";